import { css } from "@emotion/css";
import { space, text } from "@octopusdeploy/design-system-tokens";

export const sharedStyles = {
    header: css({
        font: text.body.bold.large,
        marginTop: 0,
        marginBottom: space[16],
    }),
};
